import React from "react";
import { ReactComponent as ChandelierSvg } from "../svg/chandelier.svg";

export default function ChandelierIcon({ size = 64, color = "#32363F", ...props }) {
  return <ChandelierSvg width={size} height={size} style={{ color }} {...props} />;
}
